import React from 'react';
import { AgencyList } from './AgencyList';
import { AgencyFilters } from './AgencyFilters';
import { UserManagement } from './UserManagement';
import { PermissionsManagement } from './PermissionsManagement';
import { useAgencies } from '../../hooks/useAgencies';
import { AdminStats } from './AdminStats';
import { AdminReports } from './AdminReports';

export const AdminDashboard: React.FC = () => {
  const { isLoading } = useAgencies();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Tableau de bord administrateur
          </h1>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Gérez les agences, leurs abonnements, les utilisateurs et les permissions
          </p>
        </div>

        <div className="space-y-8">
          {/* Statistiques et rapports */}
          <AdminStats />
          <AdminReports />

          {/* Gestion des utilisateurs */}
          <UserManagement />
          
          {/* Gestion des permissions */}
          <PermissionsManagement />

          {/* Gestion des agences */}
          <div className="space-y-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Gestion des agences
            </h2>
            <AgencyFilters />
            {isLoading ? (
              <div className="mt-8 space-y-4">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="h-24 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
                  />
                ))}
              </div>
            ) : (
              <AgencyList />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};